import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MaterialIcon from '../components/MaterialIcon';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error' | null

  // 服务类型映射，将value转换为用户看到的中文文本
  const getServiceText = (value) => {
    const serviceMap = {
      'personal': '个人教练',
      'enterprise': '企业教练',
      'training': '教练培训'
    };
    return serviceMap[value] || value;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 验证必填字段
    if (!formData.name.trim() || !formData.phone.trim()) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // 准备提交数据
      const submitData = {
        type: 1, // 联系页面默认为个人 (1=个人, 2=企业)
        name: formData.name ? formData.name.substring(0, 32) : null, // 最大32字符
        phone: formData.phone.substring(0, 32), // 必填，最大32字符
        company: null, // 联系页面不收集公司信息
        service: formData.service ? getServiceText(formData.service) : null // 咨询类型转换为中文
      };

      const response = await fetch('https://open.ga.api.betterus.cc/api/custom/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(submitData),
      });

      if (response.ok) {
        setSubmitStatus('success');
        // 清空表单
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        throw new Error('提交失败');
      }
    } catch (error) {
      console.error('表单提交错误:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="container mx-auto px-4 py-20">
        <h1 className="text-4xl font-bold text-center text-brand-dark mb-12">联系我们</h1>
        <div className="max-w-2xl mx-auto">
          {/* 成功提示 */}
          {submitStatus === 'success' && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-center space-x-3 mb-6">
              <MaterialIcon icon="check_circle" className="text-green-500" />
              <div>
                <p className="text-green-800 font-medium">提交成功！</p>
                <p className="text-green-600 text-sm">我们将尽快与您联系</p>
              </div>
            </div>
          )}

          {/* 错误提示 */}
          {submitStatus === 'error' && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center space-x-3 mb-6">
              <MaterialIcon icon="error" className="text-red-500" />
              <div>
                <p className="text-red-800 font-medium">提交失败</p>
                <p className="text-red-600 text-sm">请检查必填字段或稍后重试</p>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-brand-text mb-2">姓名 <span className="text-red-500">*</span></label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-control"
                placeholder="请输入您的姓名"
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-brand-text mb-2">邮箱</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
                placeholder="请输入您的邮箱"
              />
            </div>
            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-brand-text mb-2">电话 <span className="text-red-500">*</span></label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-control"
                placeholder="请输入您的电话"
                required
              />
            </div>
            <div>
              <label htmlFor="service" className="block text-sm font-medium text-brand-text mb-2">咨询类型</label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                className="form-control"
              >
                <option value="">请选择咨询类型</option>
                <option value="personal">个人教练</option>
                <option value="enterprise">企业教练</option>
                <option value="training">教练培训</option>
              </select>
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-brand-text mb-2">留言</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="form-control"
                placeholder="请输入您的留言"
              ></textarea>
            </div>
            <button
              type="submit"
              disabled={isSubmitting || submitStatus === 'success'}
              className={`w-full py-3 px-6 rounded-lg font-medium transition-all duration-300 ${
                isSubmitting || submitStatus === 'success'
                  ? 'bg-gray-400 cursor-not-allowed text-white'
                  : 'btn btn-primary hover:bg-brand-primary/90'
              }`}
            >
              {isSubmitting ? (
                <div className="flex items-center justify-center space-x-2">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>提交中...</span>
                </div>
              ) : submitStatus === 'success' ? (
                <div className="flex items-center justify-center space-x-2">
                  <MaterialIcon icon="check" />
                  <span>提交成功</span>
                </div>
              ) : (
                '提交预约'
              )}
            </button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Contact; 
